<!-- Переводы — чистые пайпы: при смене языка страница создаётся заново -->
<ng-container *ngFor="let lang of [language]">

  <header class="hero" [style.background-image]="restaurant.image ? 'url(' + restaurant.image + ')' : null">
    <div class="wrap hero__content">
      <img *ngIf="restaurant.logo" class="hero__logo" [src]="restaurant.logo" alt="" />
      <div>
        <h1>{{ restaurant | titleTranslate }}</h1>
        <div class="hero__sub" *ngIf="restaurant.description">{{ restaurant.description }}</div>
      </div>
    </div>
  </header>

  <div class="info">
    <div class="wrap info__content">
      <span class="notice" *ngIf="allergyNotice$ | async">
        <svg viewBox="0 0 24 24" width="18" height="18"><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></svg>
        {{ 'allergyNotice' | translate }}
      </span>
      <span class="spacer"></span>
      <button class="link" *ngIf="details" (click)="contactsOpen = true">{{ 'contactsAndDetails' | translate }}</button>
    </div>
  </div>

  <div class="tabs-anchor"></div>
  <nav class="tabs">
    <div class="wrap tabs__content">
      <div class="tabs__strip" #tabStrip>
        <button class="tab" *ngFor="let tab of tabs" [class.on]="!query && tab.category.id === active" (click)="scrollTo(tab)">
          {{ tab.category | titleTranslate }}
        </button>
      </div>
      <!-- Поле поиска — всегда: порог в 30 позиций только у мобильной лупы -->
      <label class="search">
        <svg viewBox="0 0 24 24" width="18" height="18"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
        <input type="search" [value]="query" (input)="onQuery($any($event.target).value)" [placeholder]="'searchMenu' | translate" />
        <button class="search__clear" *ngIf="query" (click)="clearSearch()" aria-label="✕">
          <svg viewBox="0 0 24 24" width="16" height="16"><path d="M6 6l12 12M18 6 6 18" /></svg>
        </button>
      </label>
    </div>
  </nav>

  <main class="wrap">
    <!-- Поиск: результаты вместо меню -->
    <section *ngIf="query; else menu" class="results">
      <ng-container *ngIf="results.length; else nothing">
        <h2>{{ 'found' | translate }}: {{ results.length }}</h2>
        <div class="grid">
          <app-desktop-item-card *ngFor="let entry of results" [entry]="entry" (open)="open(entry)"></app-desktop-item-card>
        </div>
      </ng-container>
      <ng-template #nothing>
        <div class="nothing">
          <h2>{{ 'nothingFound' | translate }} «{{ query }}»</h2>
          <p>{{ 'nothingFoundHint' | translate }}</p>
          <button class="ghost" (click)="clearSearch()">{{ 'allMenu' | translate }}</button>
        </div>
      </ng-template>
    </section>

    <ng-template #menu>
      <app-desktop-events></app-desktop-events>

      <section *ngIf="premiere as section" class="section" [id]="anchor(section.category)">
        <h2>{{ section.category | titleTranslate }}</h2>
        <div class="grid">
          <app-desktop-item-card *ngFor="let entry of section.items" [entry]="entry" [hideLabels]="[Labels.premiere]"
            (open)="open(entry)"></app-desktop-item-card>
        </div>
      </section>

      <section *ngFor="let section of sections" class="section" [id]="anchor(section.category)">
        <h2>{{ section.category | titleTranslate }}</h2>
        <div class="grid">
          <app-desktop-item-card *ngFor="let entry of section.items" [entry]="entry"
            (open)="open(entry)"></app-desktop-item-card>
        </div>
      </section>

      <app-desktop-allergens *ngIf="allergyNotice$ | async"></app-desktop-allergens>
    </ng-template>
  </main>

  <app-desktop-footer [restaurant]="restaurant" [languages]="languages" [language]="language"
    [showContacts]="!!details" [linkCopied]="copied === 'menu'" (languageChange)="setLanguage($event)"
    (contacts)="contactsOpen = true" (copyLink)="copyMenuLink()"></app-desktop-footer>

  <app-desktop-item-dialog *ngIf="opened as entry" [entry]="entry" [items]="items" [categories]="categories"
    [linkCopied]="copied === 'item'"
    (close)="closeDialog()" (select)="open($event)"
    (copyLink)="copyItemLink()"></app-desktop-item-dialog>

  <!-- Контакты и реквизиты — как в мобильном подвале -->
  <div class="contacts" *ngIf="contactsOpen && details as d" (click)="closeContacts()">
    <div class="contacts__card" (click)="$event.stopPropagation()">
      <button class="contacts__close" (click)="closeContacts()" aria-label="✕">
        <svg viewBox="0 0 24 24" width="18" height="18"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
      <h3>{{ 'contactsAndDetails' | translate }}</h3>
      <p *ngIf="d.title"><b>{{ d.title }}</b></p>
      <p *ngIf="d.inn">ИНН: {{ d.inn }}</p>
      <p *ngIf="d.kpp">КПП: {{ d.kpp }}</p>
      <p *ngIf="d.ogrn">ОГРН: {{ d.ogrn }}</p>
      <p *ngIf="d.address">{{ 'address' | translate }}: {{ d.address }}</p>
      <p *ngIf="d.phone">{{ 'phone' | translate }}: <a [href]="'tel:' + d.phone">{{ d.phone }}</a></p>
      <p *ngIf="d.email">Email: <a [href]="'mailto:' + d.email">{{ d.email }}</a></p>
    </div>
  </div>
</ng-container>
